import { render, staticRenderFns } from "./DeliveryDocket.vue?vue&type=template&id=c00930c4&"
import script from "./DeliveryDocket.vue?vue&type=script&lang=js&"
export * from "./DeliveryDocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports